import { render, staticRenderFns } from "./GiftFAQ.vue?vue&type=template&id=d57a6e04&scoped=true"
import script from "./GiftFAQ.vue?vue&type=script&lang=js"
export * from "./GiftFAQ.vue?vue&type=script&lang=js"
import style0 from "./GiftFAQ.vue?vue&type=style&index=0&id=d57a6e04&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57a6e04",
  null
  
)

export default component.exports